import React from "react";

import destination_1 from "../../public/wheretogo-sumava/plechy/destination_1.png";
import destination_2 from "../../public/wheretogo-sumava/plechy/destination_2.png";
import destination_3 from "../../public/wheretogo-sumava/plechy/destination_3.png";
import destination_4 from "../../public/wheretogo-sumava/plechy/destination_4.png";
import destination_5 from "../../public/wheretogo-sumava/plechy/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-sumava/plechy/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-sumava/plechy/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-sumava/plechy/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-sumava/plechy/icon_4.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const Plechy = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Plechý</h1>
            <p>
              Nejvyšší hora české části Šumavy (1.378 m) leží asi 14 km západně
              od Horní Plané a asi 8 km jihozápadně od Nové Pece na státní
              hranici ČR s Rakouskem. Hora přitahuje návštěvníky řadou
              zajímavostí. Nejatraktivnější je ledovcové Plešné jezero, které
              nebylo řadu let přístupné veřejnosti.
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__icons--container">
            <div className="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>turistické trasy</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>výhled na Rakousko</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>1378 m. n. m.</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>památník</p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`destinations__attractions ${darkMode ? "dark" : "light"}`}
      >
        <div className="container">
          <div className="destinations__attractions--container">
            <div className="destinations__attractions--image">
              <img className="destination_1" src={destination_2} alt="" />
              <img className="destination_2" src={destination_3} alt="" />
              <img className="destination_3" src={destination_4} alt="" />
              <img className="destination_4" src={destination_5} alt="" />
            </div>
            <div className="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Hora Plechý získala svůj název pravděpodobně z německého názvu
                  Pleckhenstein, čili lesknoucí se kámen nebo skála. Inspirací k
                  tomuto pojmenování byla pravděpodobně třpytící se hladina
                  ledovcového Plešného jezera.
                </li>
                <li>
                  Na úpatí hory stojí Stifterův památník, připomínající básníka
                  z nedaleké Horní Plané Adalberta Stiftera.
                </li>
                <li>
                  Na vrcholu jsou extrémní klimatické podmínky: teplota
                  nedosahuje ani 3 °C v ročním průměru, roční srážkové úhrny se
                  pohybují mezi 1400 až 1700 mm včetně sněhové pokrývky až 250
                  cm.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Plechy;
